import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ProjectFilter = ({ 
  searchTerm, 
  onSearchChange, 
  selectedCategory, 
  onCategoryChange, 
  selectedTechnology, 
  onTechnologyChange,
  selectedStatus,
  onStatusChange,
  onClearFilters,
  categories,
  technologies,
  statuses,
  totalProjects,
  filteredCount
}) => {
  const hasActiveFilters = searchTerm || selectedCategory !== 'all' || selectedTechnology !== 'all' || selectedStatus !== 'all';

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-card rounded-lg border border-border p-6 mb-8"
    >
      {/* Search and Clear */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search projects by name, description, or technology..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full"
          />
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
            className="sm:w-auto"
          >
            Clear Filters
          </Button>
        )}
      </div>

      {/* Filter Options */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Select
          label="Category"
          options={categories}
          value={selectedCategory}
          onChange={onCategoryChange}
          placeholder="All Categories"
        />
        
        <Select
          label="Technology"
          options={technologies}
          value={selectedTechnology}
          onChange={onTechnologyChange}
          placeholder="All Technologies"
          searchable
        />
        
        <Select
          label="Status"
          options={statuses}
          value={selectedStatus}
          onChange={onStatusChange}
          placeholder="All Statuses"
        />
      </div>

      {/* Results Summary */}
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={16} />
          <span>
            Showing {filteredCount} of {totalProjects} projects
          </span>
        </div>
        {hasActiveFilters && (
          <div className="flex items-center space-x-1">
            <Icon name="AlertCircle" size={14} />
            <span>Filters active</span>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProjectFilter;